'use client';

import { c as _c } from "react/compiler-runtime";
import posthog from 'posthog-js';
import { useEffect } from 'react';
import { selectAuthUser } from '@/features/auth/store/selectors';
import { ehTelaDoEnvioArbitral } from '@/shared/constants/publicRoutes';
import type { PostHogUserContext } from '@/shared/types/posthog';
import { getPostHogConfig } from '@/shared/utils/posthogConfig';
import { redactPostHogEvent } from '@/shared/utils/posthogRedaction';
import { useAppSelector } from '@/store/hooks';
const postHogConfig = getPostHogConfig();
let isPostHogInitialized = false;
function mapUserToPostHogContext(user: NonNullable<ReturnType<typeof selectAuthUser>>): PostHogUserContext {
  return {
    empresaId: user.empresaId,
    escritorioId: user.lastWorkspaceId ?? user.escritorioId ?? null,
    tipoUsuario: user.tipoUsuario
  };
}
export function PostHog() {
  const $ = _c(4);
  const user = useAppSelector(selectAuthUser);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  useEffect(_temp, t0);
  let t1;
  let t2;
  if ($[1] !== user) {
    t1 = () => {
      if (!postHogConfig || !isPostHogInitialized) {
        return;
      }
      if (!user) {
        posthog.reset();
        return;
      }
      posthog.identify(user.id, mapUserToPostHogContext(user));
    };
    t2 = [user];
    $[1] = user;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useEffect(t1, t2);
  return null;
}
function _temp() {
  if (!postHogConfig || isPostHogInitialized || ehTelaDoEnvioArbitral(location.pathname)) {
    return;
  }
  posthog.init(postHogConfig.key, {
    api_host: postHogConfig.apiHost,
    ui_host: postHogConfig.uiHost,
    capture_pageview: false,
    capture_pageleave: true,
    disable_session_recording: false,
    session_recording: {
      maskAllInputs: true,
      maskTextSelector: "[data-dd-privacy=\"mask\"]"
    },
    autocapture: true,
    persistence: "localStorage+cookie",
    before_send: redactPostHogEvent
  });
  posthog.register({
    environment: postHogConfig.environment
  });
  isPostHogInitialized = true;
}